import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/GraphicalD.css";
import AnimatedBack from "../images/AnimatedBack.gif";
import GD1 from "../images/GD1.png";
import GD2 from "../images/GD2.gif";
import GD3 from "../images/GD3.gif";
import GD4 from "../images/GD4.gif";
import GD5 from "../images/GD5.gif";
import GD6 from "../images/GD6.gif";
import GD7 from "../images/GD7.gif";
import GD8 from "../images/GD8.png";
import GD9 from "../images/GD9.png";
import GD10 from "../images/GD10.png";
import GD11 from "../images/GD11.png";
import GD12 from "../images/GD12.png";
import GD13 from "../images/GD13.png";
import GD14 from "../images/GD14.png";
import GD15 from "../images/GD15.png";
import GD16 from "../images/GD16.png";
import GD17 from "../images/GD17.png";
import GD18 from "../images/GD18.png";
import GD19 from "../images/GD19.png";
import GD20 from "../images/GD20.png";
import GD21 from "../images/GD21.png";
import GD22 from "../images/GD22.png";

function GraphcDesign() {
  return (
    <>
      <Header />
      <div className="GD">
        <div className="Webd-above">
          <img className="Webd-img" src={AnimatedBack} alt="" />
          <div className="Webd-above-info">
            <p className="Webd-p">Graphic design and multimedia</p>
            <p
              className="Webd-p"
              style={{ marginTop: "0px", marginBottom: "0px" }}
            >
              services
            </p>
            <p className="Webd-p1"style={{ marginTop: "0px", marginBottom: "40px" }}>
              Enhance your website with our exceptional and visually stunning
              Graphic Design services, designed to elevate your brand and
              captivate your audience.
            </p>
          </div>
        </div>
        <div className="Gd-main">
          <p className="Gd-main-p">
            To truly stand out from the competition, your company needs a strong
            visual strategy. High-quality materials alone aren’t enough; pairing
            great content with captivating design can amplify the impact of your
            marketing efforts. We work closely with you to ensure your design
            project is completed on time, within budget, and aligns perfectly
            with your business goals.
          </p>
          <div className="Gd-main1">
            <div className="Gd-main1-sections">
              <div className="Gd-main1-section" style={{ textAlign: "center" }}>
                <div className="Gd-main1-section-info">
                  <p style={{ color: "black", fontWeight: "bold" }}>
                    Creative Banner Designing
                  </p>
                  <p style={{ marginTop: "10px" }}>
                    A professionally designed, eye-catching banner creates an
                    immediate impact, grabbing visitors' attention and enticing
                    them to visit your website or make a purchase. It serves as
                    a powerful tool to boost engagement and highlight your key
                    offerings.
                  </p>
                </div>
                <img className="Gd-main1-section-img" src={GD2} alt="" />
              </div>
              <div className="Gd-main1-section" style={{ textAlign: "center" }}>
                <div className="Gd-main1-section-info">
                  <p style={{ color: "black", fontWeight: "bold" }}>
                    Website Banner Designing
                  </p>
                  <p style={{ marginTop: "10px" }}>
                    Professional web banners designed by us can significantly
                    elevate your business, helping you stand out in crowded
                    markets and attract more customers. With visually compelling
                    designs, we ensure your brand makes a strong impression and
                    drives growth in competitive industries.
                  </p>
                </div>
                <img className="Gd-main1-section-img" src={GD3} alt="" />
              </div>
              <div className="Gd-main1-section" style={{ textAlign: "center" }}>
                <div className="Gd-main1-section-info">
                  <p style={{ color: "black", fontWeight: "bold" }}>
                    Ecommerce Products Designing
                  </p>
                  <p style={{ marginTop: "10px" }}>
                    At Purohit technosoft, we understand that every business is
                    unique, and we know what works in the e-commerce world. Each
                    program is carefully tailored to meet your specific needs,
                    helping you unlock your business’s full potential, achieve
                    long-term growth, and stay ahead in a competitive market.
                  </p>
                </div>
                <img className="Gd-main1-section-img" src={GD4} alt="" />
              </div>
            </div>
            <img className="Gd-main1-img" src={GD1} alt="" />
            <div className="Gd-main1-sections">
              <div className="Gd-main1-section">
                <img className="Gd-main1-section-img" src={GD5} alt="" />
                <div className="Gd-main1-section-info">
                  <p style={{ color: "black", fontWeight: "bold" }}>
                    Catalog Design
                  </p>
                  <p style={{ marginTop: "10px" }}>
                    The design of your catalogue should be trendy and
                    captivating to grab your customer's attention and showcase
                    your products effectively. Choosing the right design to
                    highlight product information, special offers, and more is
                    crucial—and Purohit Technosoft is here to help you with all
                    of that.
                  </p>
                </div>
              </div>
              <div className="Gd-main1-section">
                <img className="Gd-main1-section-img" src={GD6} alt="" />
                <div className="Gd-main1-section-info">
                  <p style={{ color: "black", fontWeight: "bold" }}>
                    Portfolio Design
                  </p>
                  <p style={{ marginTop: "10px" }}>
                    A portfolio provides valuable insights into a specific trait
                    or organization, allowing potential clients to learn more
                    about what we offer. We focus on creating a portfolio that
                    aligns with your needs, helping you evaluate if we're the
                    right fit to support and grow your business.
                  </p>
                </div>
              </div>
              <div className="Gd-main1-section">
                <img className="Gd-main1-section-img" src={GD7} alt="" />
                <div className="Gd-main1-section-info">
                  <p style={{ color: "black", fontWeight: "bold" }}>
                    Creative Banners for Social Media
                  </p>
                  <p style={{ marginTop: "10px" }}>
                    Creating social media banners can attract a large audience,
                    especially younger users, to your website, making it more
                    engaging. We offer eye-catching and innovative banners
                    designed specifically for your social media platform,
                    helping you boost visibility and drive traffic.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="Gd-main2">
  <p className="Gd-main2-p">Why Choose us for Graphic Design Service?</p>
  <p className="Gd-main2-p1">
    Our talented graphic designers have explored a wide range of concepts to bring you
    the best in graphics, animation, and multimedia, ensuring creativity and innovation
    are at the heart of every design.
  </p>

  <div className="Gd-main2-cards">
    <div className="Gd-main2-card card1">
      <img src={GD16} alt="2D animation" />
      <p className="card-title">2D animation</p>
      <p>
        As a reputable graphic design and multimedia services provider, we assist
        industries such as marketing, gaming, and entertainment with a wide range of
        high-quality 2D animation services, bringing creativity and impact to every project.
      </p>
    </div>

    <div className="Gd-main2-card card2">
      <img src={GD17} alt="3D animation" />
      <p className="card-title">3D animation</p>
      <p>
        We use the latest 3D technology and tools to bring your creative ideas to life
        through stunning and high-quality 3D animations.
      </p>
    </div>

    <div className="Gd-main2-card card3">
      <img src={GD18} alt="Animated illustrations" />
      <p className="card-title">Animated illustrations</p>
      <p>
        Our experts deliver eye-catching graphics that captivate your audience, whether
        you need simple illustrations or intricate custom designs tailored to your vision.
      </p>
    </div>

    <div className="Gd-main2-card card4">
      <img src={GD19} alt="Flash Animation" />
      <p className="card-title">Flash Animation</p>
      <p>
        Flash animation is one of the most effective ways to capture the attention of your
        web visitors. It has become a powerful tool that can make your designs stand out.
      </p>
    </div>

    <div className="Gd-main2-card card5">
      <img src={GD20} alt="Product animation" />
      <p className="card-title">Product animation</p>
      <p>
        Before final production, designers use detailed product animations to showcase
        features and aspects of the product, providing clear and engaging presentations.
      </p>
    </div>

    <div className="Gd-main2-card card6">
      <img src={GD21} alt="Comprehensive services" />
      <p className="card-title">Comprehensive animation services</p>
      <p>
        We offer a diverse range of animation services for gaming, movies, medical,
        eLearning, and more, delivering tailored solutions for each sector.
      </p>
    </div>

    <div className="Gd-main2-card card7">
      <img src={GD22} alt="Animated Logo Design" />
      <p className="card-title">Animated Logo Design</p>
      <p>
        Your logo is your brand face. We create animated logo designs that enhance
        recognition and build a strong digital identity.
      </p>
    </div>
  </div>
</div>

          <div className="Webd-main2">
            <p className="Webd-main2-p">Mobile App Development Services</p>
            <p className="Webd-main2-p1">
              Obtain Mobile App Services to Expand Your Business Worldwide.
            </p>
            <div className="Appd-main2-boxes" style={{marginLeft:"-40px"}}>
              <div className="Appd-main2-box">
                <img className="Appd-main2-img" src={GD8} alt="" />
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Custom Design
                </p>
                <p style={{ marginTop: "20px" }}>
                  Designing animations, banners, and presentations optimized for
                  low bandwidth
                </p>
              </div>
              <div className="Appd-main2-box">
                <img className="Appd-main2-img" src={GD9} alt="" />
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Visually captivating animations
                </p>
                <p style={{ marginTop: "20px" }}>
                  Animations that are simple to understand and spectacular.
                </p>
              </div>
              <div className="Appd-main2-box">
                <img className="Appd-main2-img" src={GD10} alt="" />
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Easy to Read Text
                </p>
                <p style={{ marginTop: "20px" }}>
                  Use high-resolution images and ensure text is easily readable
                  in videos.
                </p>
              </div>
              <div className="Appd-main2-box">
                <img className="Appd-main2-img" src={GD11} alt="" />
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Consistent follow-ups for design approval
                </p>
                <p style={{ marginTop: "20px" }}>
                  Creating an outstanding logo requires a team of skilled
                  graphic designers.
                </p>
              </div>
            </div>
            <div className="Appd-main2-boxes" style={{marginLeft:"-40px"}}>
              <div className="Appd-main2-box">
                <img className="Appd-main2-img" src={GD12} alt="" />
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Expertly crafted, unique graphic designs at an affordable
                  price.
                </p>
                <p style={{ marginTop: "20px" }}>
                  Affordable brochure design services.
                </p>
              </div>
              <div className="Appd-main2-box">
                <img className="Appd-main2-img" src={GD13} alt="" />
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Skilled and professional team members.
                </p>
                <p style={{ marginTop: "20px" }}>
                  Image editing experts in dedicated teams
                </p>
              </div>
              <div className="Appd-main2-box">
                <img className="Appd-main2-img" src={GD14} alt="" />
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Custom editing Design
                </p>
                <p style={{ marginTop: "20px" }}>
                  An end-to-end photo editing solution
                </p>
              </div>
              <div className="Appd-main2-box">
                <img className="Appd-main2-img" src={GD15} alt="" />
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Timely delivery of projects
                </p>
                <p style={{ marginTop: "20px" }}>
                  Project completion on time and within budget
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default GraphcDesign;
